import type { GridProps } from "@ui/components/layout/grid/Grid";
import { space } from "ui/src/design-tokens";

export const ProductListWrapperStyles = {
    flexDirection: "column",
    alignItems: "center",
    gap: [0, 7],
    backgroundColor: "white",
    pt: [0, 0, 8],
};

export const ProductListStyles = (hasWidget: boolean): GridProps["sx"] => {
    return {
        width: "100%",
        gridTemplateColumns: [
            "repeat(2, 1fr)",
            "repeat(2, 1fr)",
            "repeat(3, 1fr)",
            "repeat(4, 1fr)",
        ],
        gridAutoRows: [hasWidget ? "auto" : "110vw", "80vw", "55vw", "45vw", "40vw"],
        gap: space["0.2"],
        rowGap: [0, 12],
        justifyContent: "space-between",
    };
};

export const EditorialWidgetStyles: GridProps["sx"] = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    inset: "0 0",
    padding: [3, 4, 6],
};
